import * as types from './constants';

const initialState = {
  data: {},
  getLoading: false,
  errors_api: {}
};

const actions = {
  // Get Account
  [types.GET_ACCOUNT_REQUEST]: state => {
    const data = {
      ...state,
      getLoading: true
    };

    return { ...data };
  },

  [types.GET_ACCOUNT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      data: payload
    };

    return { ...data };
  },

  [types.GET_ACCOUNT_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      getLoading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.UPDATE_AVATAR_URL]: (state, { payload }) => {
    const data = {
      ...state,
      data: {
        ...state.data,
        avatar_url: payload
      }
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};